import { Expose, Type } from 'class-transformer';

import { CategoryModel } from './CategoryModel';
import { ProductOptionModel } from './ProductOptionModel';

export class ProductModel {
  @Expose({ name: 'product_id' })
  id: number;

  @Expose({ name: 'menu_item_id' })
  menuItemId: number;

  @Expose()
  name: string;

  @Expose()
  description?: string;

  @Expose()
  parameter?: string;

  @Expose()
  image?: string;

  @Expose()
  price?: number;

  @Expose()
  @Type(() => CategoryModel)
  category?: CategoryModel;

  @Expose()
  composition?: string;

  @Expose()
  kcal?: number;

  @Expose()
  proteins?: number;

  @Expose()
  fats?: number;

  @Expose()
  carbohydrates?: number;

  @Expose()
  @Type(() => ProductOptionModel)
  options: ProductOptionModel[] = [];

  @Expose({ name: 'menu_items_variants' })
  menuItemsVariants?: number[];

  menuId: number;
}
